export * from './types.js';

import type { ModuleDefinition } from '@em-cms/core';

export const moduleConfig = {
  id: 'blog',
  name: 'وبلاگ',
  description: 'مدیریت مقالات و دسته‌بندی‌های وبلاگ',
  version: '0.1.0',
  is_core: false,
  requires: [],
  tables: ['cms_blog_posts', 'cms_blog_categories'],
};

export const blogModule: ModuleDefinition = {
  id: 'blog',
  name: 'وبلاگ',
  description: 'مدیریت مقالات و دسته‌بندی‌های وبلاگ',
  version: '0.1.0',
  icon: 'FileText',
  category: 'content',
  dependencies: [],
  tables: ['cms_blog_posts', 'cms_blog_categories'],
  adminRoutes: [
    {
      path: '/blog',
      component: () => import('./admin/BlogListPage').then(m => ({ default: m.BlogListPage })),
      permission: 'blog.read',
      label: 'پست‌های بلاگ',
      icon: 'FileText',
    },
    {
      path: '/blog/new',
      component: () => import('./admin/BlogEditPage').then(m => ({ default: m.BlogEditPage })),
      permission: 'blog.create',
      label: 'پست جدید',
    },
    {
      path: '/blog/edit/:id',
      component: () => import('./admin/BlogEditPage').then(m => ({ default: m.BlogEditPage })),
      permission: 'blog.update',
      label: 'ویرایش پست',
    },
  ],
};
